import React from 'react';
import { Link } from 'react-router-dom';
import { HiChevronRight } from 'react-icons/hi';

const Breadcrumbs = ({ breadcrumbLinks }) => {
  return (
    <div className="bg-gradient-to-r from-indigo-50 to-white border-b-2 border-dashed py-2">
      <div className="container max-w-7xl mx-auto px-4">
        <nav className="py-2 text-gray-600">
          <ol className="flex items-center space-x-2 text-sm">
            {breadcrumbLinks.map((link, index) => (
              <React.Fragment key={index}>
                {link.href ? (
                  <li>
                    <Link
                      to={link.href}
                      className="text-indigo-600 hover:underline font-semibold flex items-center gap-1"
                    >
                      {link.label}
                    </Link>
                  </li>
                ) : (
                  <li>
                    <span className="text-gray-800 font-bold">
                      {link.label}
                    </span>
                  </li>
                )}
                {index < breadcrumbLinks.length - 1 && (
                  <li className="text-gray-400">
                    <HiChevronRight className="inline-block w-4 h-4" />
                  </li>
                )}
              </React.Fragment>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumbs;
